const en = {
    title: 'Team processing',
    allAccessible: 'All accessible accounts and folders',
    businessIncoming: 'Incoming business mail',
    workspace: 'Workspace',
    privateAccount: 'Private account work',
    status: 'Processing status',
    OPEN: 'Open',
    IN_PROGRESS: 'In progress',
    DONE: 'Done',
    unread: 'Unread',
    read: 'Read',
    readAll: 'Read and unread',
    markRead: 'Mark as read',
    markUnread: 'Mark as unread',
    claim: 'Claim',
    save: 'Save change',
    assignee: 'Assigned to',
    unowned: 'Unassigned work',
    ownerAll: 'All assignments',
    reason: 'Reason for change',
    reasonHint: 'Enter at least three characters.',
    stale: 'Another person changed this item. Refresh its current status before trying again.',
    denied: 'Access changed. Reload the message to check current permissions.',
    loadFailed: 'Processing information could not be loaded.',
    choose: 'Choose',
    none: 'No available results',
    search: 'Search',
    account: 'Mailbox',
    partner: 'Partner',
    role: 'Partner role',
    CUSTOMER: 'Customer',
    PROSPECT: 'Prospect',
    SUPPLIER: 'Supplier',
    association: 'Partner association',
    LINKED: 'Associated',
    UNASSIGNED: 'No visible association',
    AMBIGUOUS: 'Association needs a decision',
    spam: 'Spam',
    spamOnly: 'Spam only',
    spamExclude: 'Exclude spam',
    spamAll: 'Include spam',
    attachments: 'Attachments',
    withAttachments: 'With attachments',
    withoutAttachments: 'Without attachments',
    dateFrom: 'From date',
    dateTo: 'Through date',
    filters: 'Filters',
    reset: 'Reset filters',
    workUnavailable: 'Drafts and spam are not available for processing.',
    selectWorkspace: 'Choose a workspace to view and change its processing status.',
    privateHint: 'This account’s processing is separate from the business workspace.',
    businessHint: 'Only released business copies share this processing status.',
    success: 'Change saved.',
    direction: 'Direction',
    allDirections: 'All directions',
    INCOMING: 'Incoming',
    OUTGOING: 'Outgoing',
    all: 'All',
    refresh: 'Refresh status',
    accountRequired: 'Choose a mailbox for the account workspace.',
    scopeRequired: 'Choose a specific workspace for processing filters.',
    dateInvalid: 'The end date must not precede the start date.',
    scopesEmpty: 'No processing workspace is currently accessible.',
    historyHint: 'Reading is personal. Completing work is a separate decision.',
    assigneeUnavailable: 'This person cannot currently process this message.',
    noChanges: 'Choose a status or assignment to change.',
    reasonInvalid: 'Enter a reason of at least three characters.',
    selectionNext: 'More results',
    selectionStart: 'First results',
    selectionFailed: 'Options could not be loaded.',
    unknownPerson: 'Former team member',
};
export const mailWorkflowLabels = {
    en,
    de: {
        title: 'Teambearbeitung',
        allAccessible: 'Alle zugänglichen Konten und Ordner',
        businessIncoming: 'Geschäftliche Eingänge',
        workspace: 'Arbeitsbereich',
        privateAccount: 'Private Kontobearbeitung',
        status: 'Bearbeitungsstatus',
        OPEN: 'Offen',
        IN_PROGRESS: 'In Bearbeitung',
        DONE: 'Erledigt',
        unread: 'Ungelesen',
        read: 'Gelesen',
        readAll: 'Gelesen und ungelesen',
        markRead: 'Als gelesen markieren',
        markUnread: 'Als ungelesen markieren',
        claim: 'Übernehmen',
        save: 'Änderung speichern',
        assignee: 'Zuständig',
        unowned: 'Ohne Zuständigkeit',
        ownerAll: 'Alle Zuständigkeiten',
        reason: 'Grund der Änderung',
        reasonHint: 'Mindestens drei Zeichen eingeben.',
        stale: 'Eine andere Person hat den Vorgang geändert. Vor einem erneuten Versuch den aktuellen Status laden.',
        denied: 'Der Zugriff hat sich geändert. Nachricht neu laden, um die aktuellen Rechte zu prüfen.',
        loadFailed: 'Bearbeitungsinformationen konnten nicht geladen werden.',
        choose: 'Auswählen',
        none: 'Keine verfügbaren Ergebnisse',
        search: 'Suchen',
        account: 'Postfach',
        partner: 'Geschäftspartner',
        role: 'Partnerrolle',
        CUSTOMER: 'Kunde',
        PROSPECT: 'Interessent',
        SUPPLIER: 'Lieferant',
        association: 'Partnerzuordnung',
        LINKED: 'Zugeordnet',
        UNASSIGNED: 'Ohne sichtbare Zuordnung',
        AMBIGUOUS: 'Zuordnung benötigt Entscheidung',
        spam: 'Spam',
        spamOnly: 'Nur Spam',
        spamExclude: 'Spam ausblenden',
        spamAll: 'Spam einbeziehen',
        attachments: 'Anhänge',
        withAttachments: 'Mit Anhängen',
        withoutAttachments: 'Ohne Anhänge',
        dateFrom: 'Ab Datum',
        dateTo: 'Bis Datum',
        filters: 'Filter',
        reset: 'Filter zurücksetzen',
        workUnavailable: 'Entwürfe und Spam stehen nicht zur Bearbeitung bereit.',
        selectWorkspace: 'Einen Arbeitsbereich wählen, um dessen Bearbeitungsstatus anzuzeigen und zu ändern.',
        privateHint: 'Die Bearbeitung dieses Kontos ist vom Geschäftsbereich getrennt.',
        businessHint: 'Nur freigegebene geschäftliche Kopien teilen diesen Bearbeitungsstatus.',
        success: 'Änderung gespeichert.',
        direction: 'Richtung',
        allDirections: 'Alle Richtungen',
        INCOMING: 'Eingehend',
        OUTGOING: 'Ausgehend',
        all: 'Alle',
        refresh: 'Status neu laden',
        accountRequired: 'Für den Kontobereich ein Postfach wählen.',
        scopeRequired: 'Für Bearbeitungsfilter einen bestimmten Arbeitsbereich wählen.',
        dateInvalid: 'Das Enddatum darf nicht vor dem Anfangsdatum liegen.',
        scopesEmpty: 'Derzeit ist kein Bearbeitungsbereich zugänglich.',
        historyHint: 'Lesen ist persönlich. Eine Bearbeitung wird gesondert abgeschlossen.',
        assigneeUnavailable: 'Diese Person kann die Nachricht derzeit nicht bearbeiten.',
        noChanges: 'Einen Status oder eine Zuständigkeit zum Ändern wählen.',
        reasonInvalid: 'Einen Grund mit mindestens drei Zeichen eingeben.',
        selectionNext: 'Weitere Ergebnisse',
        selectionStart: 'Erste Ergebnisse',
        selectionFailed: 'Auswahl konnte nicht geladen werden.',
        unknownPerson: 'Ehemaliges Teammitglied',
    },
    fr: {
        title: 'Traitement en équipe',
        allAccessible: 'Tous les comptes et dossiers accessibles',
        businessIncoming: 'Courriels professionnels entrants',
        workspace: 'Espace de travail',
        privateAccount: 'Traitement privé du compte',
        status: 'État du traitement',
        OPEN: 'Ouvert',
        IN_PROGRESS: 'En cours',
        DONE: 'Terminé',
        unread: 'Non lu',
        read: 'Lu',
        readAll: 'Lus et non lus',
        markRead: 'Marquer comme lu',
        markUnread: 'Marquer comme non lu',
        claim: 'Prendre en charge',
        save: 'Enregistrer la modification',
        assignee: 'Responsable',
        unowned: 'Sans responsable',
        ownerAll: 'Toutes les affectations',
        reason: 'Motif de la modification',
        reasonHint: 'Saisissez au moins trois caractères.',
        stale: 'Une autre personne a modifié ce dossier. Actualisez son état avant de réessayer.',
        denied: 'Les droits ont changé. Rechargez le message pour vérifier les autorisations.',
        loadFailed: 'Les informations de traitement ne peuvent pas être chargées.',
        choose: 'Choisir',
        none: 'Aucun résultat disponible',
        search: 'Rechercher',
        account: 'Boîte de réception',
        partner: 'Partenaire',
        role: 'Rôle du partenaire',
        CUSTOMER: 'Client',
        PROSPECT: 'Prospect',
        SUPPLIER: 'Fournisseur',
        association: 'Association au partenaire',
        LINKED: 'Associé',
        UNASSIGNED: 'Aucune association visible',
        AMBIGUOUS: 'Association à confirmer',
        spam: 'Indésirables',
        spamOnly: 'Indésirables uniquement',
        spamExclude: 'Masquer les indésirables',
        spamAll: 'Inclure les indésirables',
        attachments: 'Pièces jointes',
        withAttachments: 'Avec pièces jointes',
        withoutAttachments: 'Sans pièces jointes',
        dateFrom: 'À partir du',
        dateTo: 'Jusqu’au',
        filters: 'Filtres',
        reset: 'Réinitialiser les filtres',
        workUnavailable: 'Les brouillons et indésirables ne peuvent pas être traités.',
        selectWorkspace: 'Choisissez un espace pour consulter et modifier son état de traitement.',
        privateHint: 'Le traitement de ce compte est distinct de l’espace professionnel.',
        businessHint: 'Seules les copies professionnelles partagées ont cet état commun.',
        success: 'Modification enregistrée.',
        direction: 'Sens',
        allDirections: 'Tous les sens',
        INCOMING: 'Entrant',
        OUTGOING: 'Sortant',
        all: 'Tous',
        refresh: 'Actualiser l’état',
        accountRequired: 'Choisissez une boîte pour l’espace du compte.',
        scopeRequired: 'Choisissez un espace précis pour les filtres de traitement.',
        dateInvalid: 'La date de fin ne doit pas précéder la date de début.',
        scopesEmpty: 'Aucun espace de traitement n’est actuellement accessible.',
        historyHint: 'La lecture est personnelle. Le traitement se termine séparément.',
        assigneeUnavailable: 'Cette personne ne peut pas traiter ce message actuellement.',
        noChanges: 'Choisissez un état ou une affectation à modifier.',
        reasonInvalid: 'Saisissez un motif d’au moins trois caractères.',
        selectionNext: 'Plus de résultats',
        selectionStart: 'Premiers résultats',
        selectionFailed: 'Les choix ne peuvent pas être chargés.',
        unknownPerson: 'Ancien membre de l’équipe',
    },
    es: {
        title: 'Gestión en equipo',
        allAccessible: 'Todas las cuentas y carpetas accesibles',
        businessIncoming: 'Correo empresarial entrante',
        workspace: 'Área de trabajo',
        privateAccount: 'Gestión privada de la cuenta',
        status: 'Estado de gestión',
        OPEN: 'Abierto',
        IN_PROGRESS: 'En curso',
        DONE: 'Finalizado',
        unread: 'No leído',
        read: 'Leído',
        readAll: 'Leídos y no leídos',
        markRead: 'Marcar como leído',
        markUnread: 'Marcar como no leído',
        claim: 'Asumir',
        save: 'Guardar cambio',
        assignee: 'Responsable',
        unowned: 'Sin responsable',
        ownerAll: 'Todas las asignaciones',
        reason: 'Motivo del cambio',
        reasonHint: 'Introduzca al menos tres caracteres.',
        stale: 'Otra persona ha modificado este asunto. Actualice su estado antes de volver a intentarlo.',
        denied: 'El acceso ha cambiado. Recargue el mensaje para comprobar los permisos.',
        loadFailed: 'No se pudo cargar la información de gestión.',
        choose: 'Elegir',
        none: 'No hay resultados disponibles',
        search: 'Buscar',
        account: 'Buzón',
        partner: 'Socio comercial',
        role: 'Función del socio',
        CUSTOMER: 'Cliente',
        PROSPECT: 'Cliente potencial',
        SUPPLIER: 'Proveedor',
        association: 'Asociación con el socio',
        LINKED: 'Asociado',
        UNASSIGNED: 'Sin asociación visible',
        AMBIGUOUS: 'Asociación pendiente de decisión',
        spam: 'Correo no deseado',
        spamOnly: 'Solo correo no deseado',
        spamExclude: 'Excluir correo no deseado',
        spamAll: 'Incluir correo no deseado',
        attachments: 'Adjuntos',
        withAttachments: 'Con adjuntos',
        withoutAttachments: 'Sin adjuntos',
        dateFrom: 'Desde la fecha',
        dateTo: 'Hasta la fecha',
        filters: 'Filtros',
        reset: 'Restablecer filtros',
        workUnavailable: 'Los borradores y el correo no deseado no están disponibles para gestión.',
        selectWorkspace: 'Elija un área para ver y cambiar su estado de gestión.',
        privateHint: 'La gestión de esta cuenta es independiente del área empresarial.',
        businessHint: 'Solo las copias empresariales compartidas tienen este estado común.',
        success: 'Cambio guardado.',
        direction: 'Dirección',
        allDirections: 'Todas las direcciones',
        INCOMING: 'Entrante',
        OUTGOING: 'Saliente',
        all: 'Todos',
        refresh: 'Actualizar estado',
        accountRequired: 'Elija un buzón para el área de la cuenta.',
        scopeRequired: 'Elija un área concreta para los filtros de gestión.',
        dateInvalid: 'La fecha final no puede ser anterior a la inicial.',
        scopesEmpty: 'No hay un área de gestión accesible actualmente.',
        historyHint: 'La lectura es personal. La gestión se finaliza por separado.',
        assigneeUnavailable: 'Esta persona no puede gestionar este mensaje actualmente.',
        noChanges: 'Elija un estado o una asignación para cambiar.',
        reasonInvalid: 'Introduzca un motivo de al menos tres caracteres.',
        selectionNext: 'Más resultados',
        selectionStart: 'Primeros resultados',
        selectionFailed: 'No se pudieron cargar las opciones.',
        unknownPerson: 'Antiguo miembro del equipo',
    },
    tr: {
        title: 'Ekip işlemleri',
        allAccessible: 'Erişilebilen tüm hesaplar ve klasörler',
        businessIncoming: 'Gelen iş e-postaları',
        workspace: 'Çalışma alanı',
        privateAccount: 'Özel hesap işlemleri',
        status: 'İşlem durumu',
        OPEN: 'Açık',
        IN_PROGRESS: 'İşlemde',
        DONE: 'Tamamlandı',
        unread: 'Okunmadı',
        read: 'Okundu',
        readAll: 'Okunan ve okunmayan',
        markRead: 'Okundu olarak işaretle',
        markUnread: 'Okunmadı olarak işaretle',
        claim: 'Üstlen',
        save: 'Değişikliği kaydet',
        assignee: 'Sorumlu',
        unowned: 'Sorumlu atanmamış',
        ownerAll: 'Tüm atamalar',
        reason: 'Değişiklik nedeni',
        reasonHint: 'En az üç karakter girin.',
        stale: 'Başka bir kişi bu kaydı değiştirdi. Yeniden denemeden önce güncel durumu yükleyin.',
        denied: 'Erişim değişti. Güncel izinleri kontrol etmek için mesajı yeniden yükleyin.',
        loadFailed: 'İşlem bilgileri yüklenemedi.',
        choose: 'Seçin',
        none: 'Kullanılabilir sonuç yok',
        search: 'Ara',
        account: 'Posta kutusu',
        partner: 'İş ortağı',
        role: 'İş ortağı rolü',
        CUSTOMER: 'Müşteri',
        PROSPECT: 'Müşteri adayı',
        SUPPLIER: 'Tedarikçi',
        association: 'İş ortağı eşleştirmesi',
        LINKED: 'Eşleştirildi',
        UNASSIGNED: 'Görünür eşleştirme yok',
        AMBIGUOUS: 'Eşleştirme için karar gerekli',
        spam: 'İstenmeyen posta',
        spamOnly: 'Yalnızca istenmeyen posta',
        spamExclude: 'İstenmeyen postayı hariç tut',
        spamAll: 'İstenmeyen postayı dahil et',
        attachments: 'Ekler',
        withAttachments: 'Ekli',
        withoutAttachments: 'Eksiz',
        dateFrom: 'Başlangıç tarihi',
        dateTo: 'Bitiş tarihi',
        filters: 'Filtreler',
        reset: 'Filtreleri sıfırla',
        workUnavailable: 'Taslaklar ve istenmeyen postalar işleme alınamaz.',
        selectWorkspace: 'İşlem durumunu görüntülemek ve değiştirmek için bir çalışma alanı seçin.',
        privateHint: 'Bu hesabın işlemleri iş alanından ayrıdır.',
        businessHint: 'Yalnızca paylaşılan iş kopyaları bu işlem durumunu paylaşır.',
        success: 'Değişiklik kaydedildi.',
        direction: 'Yön',
        allDirections: 'Tüm yönler',
        INCOMING: 'Gelen',
        OUTGOING: 'Giden',
        all: 'Tümü',
        refresh: 'Durumu yenile',
        accountRequired: 'Hesap alanı için bir posta kutusu seçin.',
        scopeRequired: 'İşlem filtreleri için belirli bir çalışma alanı seçin.',
        dateInvalid: 'Bitiş tarihi başlangıç tarihinden önce olamaz.',
        scopesEmpty: 'Şu anda erişilebilir işlem alanı yok.',
        historyHint: 'Okuma kişiseldir. İşlemi tamamlama ayrı bir karardır.',
        assigneeUnavailable: 'Bu kişi şu anda bu mesajı işleyemez.',
        noChanges: 'Değiştirilecek bir durum veya atama seçin.',
        reasonInvalid: 'En az üç karakterlik bir neden girin.',
        selectionNext: 'Daha fazla sonuç',
        selectionStart: 'İlk sonuçlar',
        selectionFailed: 'Seçenekler yüklenemedi.',
        unknownPerson: 'Eski ekip üyesi',
    },
};
//# sourceMappingURL=mail-workflow-labels.js.map